import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import {DRAWER_PLACEMENTS} from '@adv-mt/ui/drawer'

const useDrawerPlacement = () => {
  const {domain} = useContext(Context)
  const isMobile = domain.get('config').get('isMobile')
  const isWideViewport = useMediaQuery(useMediaQueryBreakpoints.xl, {defaultMatches: !isMobile})
  const placement = isWideViewport ? DRAWER_PLACEMENTS.RIGHT : DRAWER_PLACEMENTS.BOTTOM

  return {placement, isBottomSheet: placement === DRAWER_PLACEMENTS.BOTTOM}
}

export default useDrawerPlacement
